import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ROLES_FORM } from './role-form';
import { NbToastrService } from '@nebular/theme';
import { RolesService } from 'projects/pplus/src/lib/services/permissions/roles.service';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { DynamicForm } from 'projects/pplus/src/lib/models/components/dynamic-form.model';
import { map } from 'rxjs/operators';
import { PermissionsService } from 'projects/pplus/src/lib/services/permissions/permissions.service';
import { Role, RolePermission } from 'projects/pplus/src/lib/models/permissions/role.model';

@Component({
  selector: 'pplus-role-details',
  templateUrl: './role-details.component.html',
  styleUrls: ['./role-details.component.scss']
})
export class RoleDetailsComponent implements OnInit {
  @Output() splitOptions = new EventEmitter();
  @Output() updateDelete = new EventEmitter();

  formData = ROLES_FORM;
  formGroup: FormGroup;
  selectedRowData: any;

  constructor(private toastService: NbToastrService,
    private rolesService: RolesService,
    private dataRowService: RowDataService,
    private permissionsService: PermissionsService) { }

  ngOnInit() {
    this.generateForm(this.formData);
    this.subscribeDataRowService();
  }

  generateForm(data: DynamicForm[]) {
    this.permissionsService.getList().subscribe(permissions => {
      const fieldsCtrls = {};
      data.forEach(item => {
        const fields = item.fields;
        fields.forEach(f => {
          switch (f.name) {
            case 'permissionIds':
              f.options = [];
              permissions.map(o => {
                f.options.push({
                  label: o.description,
                  value: o.permissionId,
                });
              });
              break;
          }
          fieldsCtrls[f.name] = new FormControl(f.value, f.validators);
        });
        this.formGroup = new FormGroup(fieldsCtrls);
      });
    });
  }

  subscribeDataRowService() {
    this.dataRowService.currentRowData.pipe(map(o => {
      this.formData.forEach(data => {
        const fields = data.fields;
        fields.map(field => {
          switch (field.name) {
            case 'permissionIds':
              const rp = o['rolePermissions'];
              const values = [];
              if (rp && rp.length) { for (const x of rp) { values.push(x.permissionId); } }
              field.value = values;
              break;
            default:
              field.value = o[field.name];
              break;
          }
        });
      });
      return o;
    })).subscribe(data => {
      this.selectedRowData = data;
      this.generateForm(this.formData);
    });
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      //      this.showFormValidationErrors();
    } else {
      const role: Role = this.formGroup.value;
      role.rolePermissions = [];
      this.formGroup.value.permissionIds.forEach(x => {
        const rp = new RolePermission;
        rp.roleId = 0;
        rp.permissionId = x;
        role.rolePermissions.push(rp);
      });
      //      role.rolePermissions = this.formGroup.value.permissionIds;
      this.rolesService.create(role).subscribe(success => {
        if (success) {
          this.toastService.show('Se ha creado el nuevo elemento', 'Elemento creado');
          this.formGroup.reset();
          //          this.clearData();
          this.updateDelete.emit({ Type: 'create' });
        } else {
          this.toastService.show('Se ha producido un error al crear el dominio: ', 'ERROR');
        }
      });
    }
  }

  update() {
    if (this.formGroup.invalid) {
      //      this.showFormValidationErrors();
    } else {
      const role = this.formGroup.value;
      role.roleId = this.selectedRowData.roleId;
      role.rolePermissions = [];
      this.formGroup.value.permissionIds.forEach(x => {
        const rp = new RolePermission;
        rp.roleId = this.selectedRowData.roleId;
        rp.permissionId = x;
        role.rolePermissions.push(rp);
      });
      this.rolesService.update(role).subscribe(success => {
        if (success) {
          //          this.showToast('', 'success', 'Se ha creado el nuevo dominio: ' + data.Fqdn, 'Elemento creado');
          this.toastService.show('Se ha modificado el elemento con éxito', 'Elemento modificado');
          this.formGroup.reset();
          //          this.clearData();
          this.updateDelete.emit({ Type: 'update' });
        } else {
          this.toastService.show('Se ha producido un error al modificar el elemento: ', 'ERROR');
          //          this.showToast('', 'danger', 'Se ha producido un error al crear el dominio: ' + data.Fqdn, 'ERROR');
        }
      });
    }
  }

  delete() {
    if (this.selectedRowData.permissionId == null) {
      this.toastService.show('Seleccione un elemento', 'Info');
    } else {
      this.rolesService.delete(this.selectedRowData.permissionId).subscribe(success => {
        if (success) {
          this.toastService.show('Se ha borrado el elemento', 'Elemento eliminado');
          //          this.updateDelete.emit({Type: 'delete', EntityDomainId: this.selectedRowData.permissionId});
          //          this.clearData();
        } else {
          this.toastService.show('Se ha producido un error al intentar borrar el elemento', 'Error');
        }
      });
    }
  }

  exit() {
    const opt = {
      open: false,
      direction: 'horizontal',
      contentSize: 100,
      formSize: 0,
    };
    this.splitOptions.emit({ opt: opt, mode: 'default' });
    //    this.clearData();
  }

  copy() {
    /*    if (this.data.EntityDomainId == null) {
          this.showToast('', 'info', 'Seleccione un dominio para copiar la información', 'Info');
        } else {
          this.formType = 'create';
          this.formGroup.setValue(Object.assign(this.data, this.formGroup.value, {
            EntityDomainId: null,
            Fqdn: '',
          }));
        }
      */
  }

  openDialog(dialog: TemplateRef<any>) {
    /*    if (this.data.EntityDomainId == null) {
          this.showToast('', 'info', 'No hay ningún dominio seleccionado', 'Info');
        } else {
          this.dialog.open(dialog, { hasScroll: false });
        }
      */
  }

}
